import { useRef } from 'react';

const MOVE_TOLERANCE_PX = 10;

/**
 * Długie przytrzymanie elementu (np. karty listy). Na komputerze działa jak prawy klik.
 * Po wywołaniu blokuje następujące po nim kliknięcie, żeby nie otworzyć linku.
 */
export function useLongPress(onLongPress: () => void, ms = 500) {
  const timer = useRef<number | null>(null);
  const fired = useRef(false);
  const origin = useRef<{ x: number; y: number } | null>(null);

  const clear = () => {
    if (timer.current !== null) window.clearTimeout(timer.current);
    timer.current = null;
  };
  const fire = () => {
    clear();
    if (fired.current) return;
    fired.current = true;
    navigator.vibrate?.(10);
    onLongPress();
  };

  return {
    onPointerDown: (e: { clientX: number; clientY: number }) => {
      fired.current = false;
      origin.current = { x: e.clientX, y: e.clientY };
      clear();
      timer.current = window.setTimeout(fire, ms);
    },
    onPointerMove: (e: { clientX: number; clientY: number }) => {
      const o = origin.current;
      if (o && Math.hypot(e.clientX - o.x, e.clientY - o.y) > MOVE_TOLERANCE_PX) clear();
    },
    onPointerUp: clear,
    onPointerCancel: clear,
    onPointerLeave: clear,
    // Android wywołuje contextmenu przy przytrzymaniu linku — zamiast menu przeglądarki pokazujemy nasze.
    onContextMenu: (e: { preventDefault(): void }) => {
      e.preventDefault();
      fire();
    },
    onClickCapture: (e: { preventDefault(): void; stopPropagation(): void }) => {
      if (!fired.current) return;
      e.preventDefault();
      e.stopPropagation();
      fired.current = false;
    },
  };
}
